import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Ducted from "@/pages/Ducted";
import Split from "@/pages/Split";
import MultiHead from "@/pages/MultiHead";
import VEU from "@/pages/VEU";
import Warranty from "@/pages/Warranty";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ducted-air-conditioning" element={<Ducted />} />
          <Route path="/split-system-air-conditioning" element={<Split />} />
          <Route path="/multi-head-split-systems" element={<MultiHead />} />
          <Route path="/veu-rebates" element={<VEU />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
